export const themeLayout = {
  TABLET_BREAKPOINT: '426px',
}
export const breakPoints = {
  '1200px': '@media(max-width: 1200px)',
  '480px': '@media(max-width: 480px)',
  '375px': '@media(max-width: 375px)',

  xs: '@media(max-width: 430px) and (min-width: 319px)',
  sm: '@media(max-width: 520px)',
  md: '@media(max-width: 768px)',
  lg: '@media(max-width: 800px)',
  xl: '@media(max-width: 1024px)',
  '2xl': '@media(max-width: 1280px)',
  '3xl': '@media(max-width: 1530px)',
  '4xl': '@media(max-width: 1920px)',
  '1024px': '@media(max-width: 1024px)',
  '980px': '@media(max-width: 980px)',
  '768px': '@media(max-width: 768px)',
  '600px': '@media(max-width: 600px)',
  '576px': '@media(max-width: 576px)',
  '425px': '@media(max-width: 425px)',
}
